<template>
    <div class="form-group">
       <validation-item :label="label" :name="validationFieldName" :rules="rules" :vid="vid">
            <template>
                <input
                    :hidden="hidden"
                    autocomplete="off"
                    :value="value"
                    @input="handleInputChange"
                    :type="type"
                    class="form-control"
                    :placeholder="placeholder"
                    :v-mask="vMask"
                /></template>
        </validation-item>
    </div>
</template>

<script>
import ValidationItem from "./ValidationItem";

export default {
    name: "ValidationInput",
    components: {ValidationItem},
    props: {
        label: {
            type: String,
            default: ''
        },
        validationFieldName: {
            type: String,
            default: ''
        },
        rules: {
            type: [String, Object, Array],
            default: ''
        },
        vid: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: 'text'
        },
        placeholder: {
            type: String,
            default: ''
        },
        value: {
            type: [String, Number],
            default: ''
        },
        hidden: {
            type: Boolean,
            default: false
        },
        vMask: {
            type: String,
            default: ''
        }
    },
    methods: {
        handleInputChange(e) {
            this.$emit('input', e.target.value)
        }
    }
}
</script>

<style scoped>

</style>
